// @ts-nocheck

import React from "react";
import classes from "./Layout.module.css";
import Logo from "./logo2.png";
import RealtimeClock from "../RealTimeClock/RealTimeClock";

function Sidebar({ status, showingsidebar, setSideBar }) {
  return (
    <>
      <div
        onClick={() => setSideBar(false)}
        className={
          showingsidebar
            ? [classes.Backdrop, classes.Appear].join(" ")
            : classes.Backdrop
        }
      ></div>
      <div
        className={
          showingsidebar
            ? [classes.SideBar, classes.slideRight].join(" ")
            : classes.SideBar
        }
      >
        <ul className={classes.Content}>
          <br /><br /><br /><br />
     
          {status === "superadmin" ? (
            <>
            <li>
              <RealtimeClock/>
            </li>
              <li>
                <a href="/namecheap">Bulk Forward</a>
              </li>
              <li>
                <a href="/v2/scrub">Scrub (v2)</a>
              </li>
              
              <li>
                <a href="/click-tracker">Click Tracker</a>
              </li>
              <li>
                <a href="/allsubs">All Subs</a>
              </li>
              <li>
                <a href="/conversion-tracker">Conversion Tracker</a>
              </li>

            </>
          ) : status === "viewer" ? (
            <>
              <li>
                <a href="/statistics">Conversion Stats</a>
              </li>
            </>
          ) : null}

          {
            status === "legal" && <>
              <li>
                <a href="/legal/leads">Opt-in Leads</a>
              </li>
            </>
          }

          <li>
            <a onClick={() => localStorage.removeItem("token")} href="/auth">
              Logout
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}

export default Sidebar;
